import { AddCartNonMatchingProductFormProvider } from "./AddCartNonMatchingProductFormProvider";
import {
  BarcodeFormInput,
  CostPriceFormInput,
  NameFormInput,
  PriceFormInput,
  QuantityFormInput,
  TaxRateFormInput,
} from "./components";

export interface AddCartNonMatchingProductFormProps {}

export const AddCartNonMatchingProductForm =
  (AddCartNonMatchingProductFormProps: {}) => {
    return null;
  };

AddCartNonMatchingProductForm.Provider = AddCartNonMatchingProductFormProvider;
AddCartNonMatchingProductForm.BarcodeFormInput = BarcodeFormInput;
AddCartNonMatchingProductForm.NameFormInput = NameFormInput;
AddCartNonMatchingProductForm.QuantityFormInput = QuantityFormInput;
AddCartNonMatchingProductForm.PriceFormInput = PriceFormInput;
AddCartNonMatchingProductForm.CostPriceFormInput = CostPriceFormInput;
AddCartNonMatchingProductForm.TaxRateFormInput = TaxRateFormInput;
